export const ANIME = 'anime';
export const DAILY = 'daily';
export const STANDARD = 'standard';
